module.exports = __webpack_public_path__ + "img/logo-jjc-grupo.b4538dfe.svg";